enum MdmUserDialogMode {
  CREATE,
  DETAIL,
  EDIT
}

export default MdmUserDialogMode;